export default __webpack_public_path__ + "static/johan-steneros@2x-41f81c9dd74e6372d6addec67c60b584.png";